import { BehaviorSubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class BackLinkService {
    private linkObj = {
        url: undefined,
        route: undefined,
        callback: undefined,
        hide: false,
        showPrice: undefined,
    };
    link = new BehaviorSubject(this.linkObj);

    setRoute(val: any) {
        this.linkObj.route = val;
        this.linkObj.url = undefined;
        this.linkObj.hide = false;
        this.link.next(this.linkObj);
    }
    setUrl(val: any) {
        this.linkObj.url = val;
        this.linkObj.route = undefined;
        this.linkObj.hide = false;
        this.link.next(this.linkObj);
    }
    setCallback(val: any, showPrice?: boolean) {
        this.linkObj.url = undefined;
        this.linkObj.route = undefined;
        this.linkObj.callback = val;
        this.linkObj.hide = false;
        this.linkObj.showPrice = showPrice;
        this.link.next(this.linkObj);
    }
    clearCallback() {
        this.linkObj.url = undefined;
        this.linkObj.route = undefined;
        this.linkObj.callback = undefined;
        this.linkObj.hide = false;
        this.link.next(this.linkObj);
    }
    show() {
        this.linkObj.url = undefined;
        this.linkObj.route = undefined;
        this.linkObj.callback = undefined;
        this.linkObj.hide = false;
        this.link.next(this.linkObj);
    }
    hide() {
        this.linkObj.url = undefined;
        this.linkObj.route = undefined;
        this.linkObj.callback = undefined;
        this.linkObj.hide = true;
        this.link.next(this.linkObj);
    }
}
